module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hydroware-success-failure-buttons"
  }, [_c('el-button', {
    ref: "successButton",
    staticClass: "hydroware-checkbox-button",
    attrs: {
      "circle": ""
    },
    on: {
      "click": _vm.successClicked
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-check",
    class: {
      'hydroware-icon-success': (_vm.successValue),
      'hydroware-icon-notChosen': (!_vm.successValue)
    }
  })]), _vm._v(" "), _c('el-button', {
    ref: "failureButton",
    staticClass: "hydroware-checkbox-button",
    attrs: {
      "circle": ""
    },
    on: {
      "click": _vm.failureClicked
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-close",
    class: {
      'hydroware-icon-fail': (_vm.failureValue),
      'hydroware-icon-notChosen': (!_vm.failureValue)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351a6113"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/hydroware-success-failure-buttons.vue
// module id = 796
// module chunks = 1